// extracted by mini-css-extract-plugin
export default {"headerBox":"CombinerBox_headerBox__ngpad","insideBox":"CombinerBox_insideBox__CrApu","currentNumBox":"CombinerBox_currentNumBox__dLir1","currentNum":"CombinerBox_currentNum__Rszvr"};